import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const DocumentPdf = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "PDF document",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="#06C"
        fillRule="evenodd"
        d="M6.5 2h8.2L19 6.3v14.2a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 20.5v-17A1.5 1.5 0 0 1 6.5 2m10.8 4L15 3.7v1.8a.5.5 0 0 0 .5.5zm.2 15h-11a.5.5 0 0 1-.5-.5v-17a.5.5 0 0 1 .5-.5H14v2.5A1.5 1.5 0 0 0 15.5 7H18v13.5a.5.5 0 0 1-.5.5m-9.384-3.89c.09.18.23.343.439.419.207.076.411.04.58-.029.318-.131.635-.436.926-.787a11.3 11.3 0 0 0 1.02-1.51 11.7 11.7 0 0 1 1.998-.405c.3.382.61.712.91.95.28.22.603.403.934.416a.85.85 0 0 0 .51-.138c.154-.1.27-.247.354-.416.09-.18.145-.37.138-.562a.85.85 0 0 0-.2-.519c-.226-.27-.596-.4-.96-.465-.38-.068-.84-.08-1.335-.05a10.95 10.95 0 0 1-.98-1.686c.25-.66.437-1.284.52-1.794.036-.218.054-.426.047-.613a1.24 1.24 0 0 0-.126-.539.7.7 0 0 0-.477-.365c-.202-.043-.41 0-.602.077-.377.151-.575.47-.65.823-.073.34-.04.736.046 1.137.088.405.238.847.43 1.295a19.71 19.71 0 0 1-1.062 2.227 7.7 7.7 0 0 0-1.483.645c-.37.219-.698.48-.896.786-.21.326-.275.714-.08 1.103m1.359-1.243q.21-.124.458-.239a8 8 0 0 1-.45.606c-.28.337-.497.516-.634.573l-.036.012a.3.3 0 0 1-.026-.044c-.055-.111-.053-.217.04-.362.106-.164.32-.353.648-.546m2.455-1.647q-.179.036-.356.077a21 21 0 0 0 .499-1.05 12 12 0 0 0 .51.858q-.327.048-.653.115m2.524.939a4 4 0 0 1-.434-.41q.343.005.612.053c.317.058.466.147.518.209a.1.1 0 0 1 .025.064.44.44 0 0 1-.059.2.3.3 0 0 1-.094.124.1.1 0 0 1-.069.016c-.091-.004-.258-.066-.499-.256m-2.224-4.746a7 7 0 0 1-.2.828 5 5 0 0 1-.089-.346c-.076-.353-.087-.63-.046-.821.037-.178.109-.249.196-.283a.5.5 0 0 1 .145-.04c.012.03.028.091.032.197q.008.183-.038.465"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
